import { INavigationItem, INavigationSection } from '@app/main/interfaces';
import { EFeatureFlags } from '@app/shared/enums/feature-flag';
import { EPermissionKeys } from '@app/shared/enums/permission-keys';
import { environment } from '@environments/environment';

export const navigationSections: INavigationSection[] = [
  {
    iconClass: 'local_fire_department',
    name: 'Fire',
    dataCy: 'fire',
    type: 'fire',
    sectionSelected: false,
  },
  {
    iconClass: 'groups',
    name: 'navigation.users-and-groups',
    type: 'user_and_groups',
    dataCy: 'users-and-groups-section',
    sectionSelected: false,
  },
  {
    iconClass: 'auto_graph',
    name: 'navigation.reports-and-analytics',
    dataCy: 'reports-and-analytics-section',
    type: 'reports_analytics',
    sectionSelected: false,
  },
  {
    iconClass: 'miscellaneous_services',
    name: 'navigation.configurations',
    dataCy: 'configurations-section',
    type: 'configurations',
    sectionSelected: false,
  },
  {
    iconClass: 'assignment_turned_in',
    name: 'claims',
    dataCy: 'claims-section',
    type: 'claims',
    sectionSelected: false,
  },
];

export const navigationFixedItems: INavigationItem[] = [
  {
    name: 'Home',
    iconClass: 'home',
    dataCy: 'home-nav-item',
    routerLink: 'home',
  },
  {
    name: 'notifications-center.nav-label',
    iconClass: 'notifications',
    dataCy: 'notification-center-nav-item',
    routerLink: 'notifications-center',
    permissionKey: EPermissionKeys.NOTIFICATION_VIEW
  }, 
  {
    name: 'invoice.title',
    iconClass: 'receipt_long',
    dataCy: 'invoice-nav-item',
    routerLink: 'invoices',
    permissionKey: EPermissionKeys.INVOICE_VIEW
  },
  {
    name: 'Patients',
    iconClass: 'person',
    dataCy: 'patients-nav-item',
    routerLink: 'patients',
    permissionKey: EPermissionKeys.PATIENT_VIEW
  },
  {
    name: 'Locations',
    iconClass: 'location_on',
    dataCy: 'location-nav-item',
    routerLink: 'locations',
    permissionKey: EPermissionKeys.LOCATION_VIEW
  },
  {
    name: 'Complaints',
    iconClass: 'report_problem',
    dataCy: 'complaints-nav-item',
    routerLink: 'complaints',
    permissionKey: EPermissionKeys.COMPLAINT_VIEW
  },
  {
    name: 'Insurances',
    iconClass: 'assignment',
    dataCy: 'patients-nav-item',
    routerLink: 'insurances',
    permissionKey: EPermissionKeys.INSURANCE_VIEW
  },
  {
    name: 'Doctors',
    iconClass: 'medical_services',
    dataCy: 'patients-nav-item',
    routerLink: 'doctors',
    permissionKey: EPermissionKeys.DOCTOR_VIEW
  },
  {
    name: 'Employers',
    iconClass: 'business',
    dataCy: 'patients-nav-item',
    routerLink: 'employers',
    permissionKey: EPermissionKeys.EMPLOYER_VIEW
  }
];

export const navigationItems: INavigationItem[] = [
  // claims
  {
    name: 'Sent Claims',
    dataCy: 'sent-claims-nav-item',
    iconClass: 'send',
    routerLink: 'sent-claims',
    section: 'claims',
    lastFromSection: true,
    permissionKey: EPermissionKeys.INVOICE_VIEW,
  },
  {
    name: 'Payments',
    dataCy: 'payments-nav-item',
    iconClass: 'payment',
    routerLink: 'eob-payments',
    section: 'claims',
    permissionKey: EPermissionKeys.INVOICE_VIEW,
  },
  {
    name: 'Import Conflicts',
    dataCy: 'import-conflicts-nav-item',
    iconClass: 'warning',
    routerLink: 'import-conflicts',
    section: 'claims',
    permissionKey: EPermissionKeys.IMPORT_VIEW,
  },
  {
    name: 'string.my-worklist',
    dataCy: 'my-worklist-nav-item',
    iconClass: 'view_kanban',
    routerLink: 'my-worklist',
    section: 'claims',
    lastFromSection: true,
    permissionKey: EPermissionKeys.INVOICE_VIEW,
  },
  {
    name: 'item-catalog.title',
    dataCy: 'item-catalog-nav-item',
    iconClass: 'menu_book',
    routerLink: 'items',
    section: 'item_and_cribs',
    permissionKey: EPermissionKeys.ITEM_VIEW,
  },
  {
    name: 'Fire Incidents',
    dataCy: 'fire',
    iconClass: 'storage_sharp',
    routerLink: 'fire',
    section: 'fire',
    lastFromSection: true,
    permissionKey: EPermissionKeys.FIREINCIDENT_VIEW,
  },
  // purchasing
  {
    name: 'work-center.orders',
    dataCy: 'replenishment-nav-item',
    iconClass: 'receipt',
    routerLink: 'replenishments',
    section: 'purchasing',
    permissionKey: EPermissionKeys.ORDERDETAIL_VIEW
  }, 
  {
    name: 'supplier.title',
    dataCy: 'suppliers-nav-item',
    iconClass: 'card_travel',
    routerLink: 'suppliers',
    section: 'purchasing',
    permissionKey: EPermissionKeys.SUPPLIER_VIEW,
  },  
  // user_and_groups
  {
    name: 'roles-permissions.title',
    dataCy: 'roles-and-permissions-nav-item',
    iconClass: 'key',
    routerLink: 'roles',
    section: 'user_and_groups',
    permissionKey: EPermissionKeys.ROLE_VIEW
  },
  {
    name: 'users.title',
    dataCy: 'users-nav-item',
    iconClass: 'account_circle',
    routerLink: 'users',
    section: 'user_and_groups',
    permissionKey: EPermissionKeys.USER_VIEW,
  },
  {
    name: 'restrictions.restrictions-title',
    dataCy: 'restrictions-nav-item',
    iconClass: 'shield',
    routerLink: 'restrictions',
    section: 'user_and_groups',
    permissionKey: EPermissionKeys.RESTRICTION_VIEW,
  },
  {
    name: 'manage-groups.title',
    dataCy: 'manage-groups-nav-item',
    iconClass: 'groups',
    routerLink: 'manage-groups',
    section: 'user_and_groups',
    lastFromSection: true,
    permissionKey: [EPermissionKeys.CRIBGROUP_VIEW, EPermissionKeys.USERGROUP_VIEW],
  },
  // reports_analytics
  {
    name: 'reports.title',
    dataCy: 'reports-nav-item',
    iconClass: 'ballot',
    routerLink: 'reports',
    section: 'reports_analytics',
    permissionKey: EPermissionKeys.REPORT_VIEW
  },
  {
    name: 'Dashboards',
    dataCy: 'dashboards-nav-item',
    iconClass: 'dashboard',
    routerLink: 'dashboards',
    section: 'reports_analytics',
    lastFromSection: true,
    permissionKey: EPermissionKeys.REPORT_VIEW
  },
  //
  {
    name: 'work-center.myOrganization',
    dataCy: 'my-organization-nav-item',
    iconClass: 'account_tree',
    routerLink: 'orgs',
    section: 'configurations',
    permissionKey: EPermissionKeys.ORG_VIEW,
  },
  {
    name: 'Settings',
    dataCy: 'settings-nav-item',
    iconClass: 'settings',
    routerLink: 'settings',
    section: 'configurations',
    permissionKey: EPermissionKeys.SETTING_VIEW,
  },
  {
    name: 'cost-centers.title',
    dataCy: 'cost-centers-nav-item',
    iconClass: 'local_atm',
    routerLink: 'cost-centers',
    section: 'configurations',
    featureFlagModule: EFeatureFlags.COST_CENTERS,
    permissionKey: EPermissionKeys.COSTCENTER_VIEW,
  },
  {
    name: 'scheduling.title',
    dataCy: 'scheduling-nav-item',
    iconClass: 'lock_clock',
    routerLink: 'scheduling',
    section: 'configurations',
    featureFlagModule: EFeatureFlags.SCHEDULING,
    permissionKey: EPermissionKeys.SCHEDULE_VIEW,
  },
  {
    name: 'Charge Code',
    dataCy: 'scheduling-nav-item',
    iconClass: 'file-invoice-dollar', // Or 'icon-charge' if custom
    routerLink: 'charge-codes',
    section: 'configurations',
    permissionKey: EPermissionKeys.CHARGECODE_VIEW,
  },
  {
    name: 'Payment Code',
    dataCy: 'scheduling-nav-item',
    iconClass: 'credit-card', // More accurate than just 'payment'
    routerLink: 'payment-codes',
    section: 'configurations',
    permissionKey: EPermissionKeys.PAYMENTCODE_VIEW,
  },
  {
    name: 'GL Accounts',
    dataCy: 'gl-accounts-nav-item',
    iconClass: 'book',
    routerLink: 'general-ledger-accounts',
    section: 'configurations',
    permissionKey: EPermissionKeys.GENERALLEDGERACCOUNT_VIEW,
  },
  {
    name: 'Fee Schedule',
    dataCy: 'scheduling-nav-item',
    iconClass: 'fee',
    routerLink: 'fee-schedules',
    section: 'configurations',
    permissionKey: EPermissionKeys.FEESCHEDULE_VIEW,
  },
  {
    name: 'string.work-categories',
    dataCy: 'work-categories-nav-item',
    iconClass: 'label',
    routerLink: 'work-categories',
    section: 'configurations',
    permissionKey: EPermissionKeys.WORKCATEGORY_VIEW,
  },
  {
    name: 'API Keys',
    dataCy: 'api-keys-nav-item',
    iconClass: 'vpn_key',
    routerLink: 'api-keys',
    section: 'configurations',
    permissionKey: EPermissionKeys.APISUBSCRIPTION_VIEW,
  },

];

export const allowedOrgsSupportCenter = ['org_900000000000000000000000'];
export const allowedOrgsSales = ['org_900000000000000000000001'];

export const externalNavItems: INavigationItem[] = [
  {
    name: 'Support Center',
    iconClass: 'support_agent',
    key: 'support_center',
    externalLink: '#/support-center',
  }
];

export const mobileFooterNavItems: INavigationItem[] = [
  {
    name: 'navigation.help',
    iconClass: 'help',
    key: 'help',
  },
  {
    name: 'navigation.feedback',
    iconClass: 'announcement',
    key: 'feedback',
  },
  {
    name: 'navigation.release-notes',
    iconClass: '  history',
    routerLink: 'home/changelog',
    key: 'changelog',
  },
  {
    name: 'navigation.logout',
    iconClass: 'logout',
    key: 'logout',
  },
];
